var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.currentProject.images),function(image,key){return _c('v-col',{key:key,staticClass:"d-flex child-flex",attrs:{"cols":"sm-6 xs-12"}},[_c('progect-image-item',{attrs:{"image":image}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }